/**
 * Login Modal — Shopify-native auth (no Ajax form posts).
 *
 * Auth modes (set via data-auth-mode on #lm-overlay):
 *   new    — passwordless via /customer_authentication/login (GET)
 *   legacy — {% form 'customer_login' %} native POST
 */

(function () {
  'use strict';

  const overlay = document.getElementById('lm-overlay');
  const card = document.getElementById('lm-card');
  const closeBtn = document.getElementById('lm-close');
  const decoEl = document.getElementById('lm-deco');
  const leftEl = document.getElementById('lm-left');

  if (!overlay) return;

  const authMode = overlay.dataset.authMode || 'legacy';
  const isLegacyAuth = authMode === 'legacy';
  const isLoggedIn = overlay.dataset.loggedIn === 'true';
  const requireLoginCheckout = overlay.dataset.requireLoginCheckout === 'true';
  const defaultReturnTo = overlay.dataset.defaultReturnTo || '/account';
  const checkoutUrl = overlay.dataset.checkoutUrl || '/checkout';

  let isOpen = false;
  let isAnimating = false;
  let currentView = 'login';
  let focusTrap = null;
  let lastFocusedEl = null;
  let mouseMoveRAF = null;
  let pendingCheckout = false;

  const VIEW_CONFIG = {
    login: {
      lines: [
        overlay.dataset.i18nLoginL1 || 'Wel',
        overlay.dataset.i18nLoginL2 || 'come',
        overlay.dataset.i18nLoginL3 || 'Back.',
      ],
      label: overlay.dataset.i18nLoginLabel || 'Member Area',
    },
    register: {
      lines: [
        overlay.dataset.i18nRegisterL1 || 'Join',
        overlay.dataset.i18nRegisterL2 || 'in',
        overlay.dataset.i18nRegisterL3 || 'Us.',
      ],
      label: overlay.dataset.i18nRegisterLabel || 'New Member',
    },
    forgot: {
      lines: [
        overlay.dataset.i18nLoginL1 || 'Wel',
        overlay.dataset.i18nLoginL2 || 'come',
        '',
      ],
      label: overlay.dataset.i18nLoginLabel || 'Member Area',
    },
  };

  /**
   * Keep auth fields inert while the modal is closed so browsers
   * don't treat hidden password/email inputs as an active login form.
   */
  function setAuthFieldsActive(active) {
    if (!overlay) return;

    if (active) {
      overlay.removeAttribute('inert');
    } else {
      overlay.setAttribute('inert', '');
    }

    overlay.querySelectorAll('input, select, textarea, button').forEach(function (el) {
      if (active) {
        el.removeAttribute('disabled');
        el.removeAttribute('tabindex');
        var ac = el.getAttribute('data-lm-ac');
        if (ac) el.setAttribute('autocomplete', ac);
        if (el.dataset.lmPasswordField === '1') {
          el.type = 'password';
        }
      } else {
        el.setAttribute('disabled', 'disabled');
        el.setAttribute('tabindex', '-1');
        if (el.matches('input, textarea, select')) {
          el.setAttribute('autocomplete', 'off');
        }
        if (el.matches('input[type="password"]') || el.dataset.lmPasswordField === '1') {
          el.dataset.lmPasswordField = '1';
          el.type = 'text';
        }
      }
    });
  }

  function setReturnTo(path) {
    document.querySelectorAll('[data-lm-return-to]').forEach(function (input) {
      input.value = path;
    });
  }

  function openModal(view, options) {
    if (isOpen || isAnimating) return;

    options = options || {};
    view = view || 'login';
    pendingCheckout = !!options.checkout;
    setReturnTo(pendingCheckout ? checkoutUrl : defaultReturnTo);

    isAnimating = true;
    lastFocusedEl = document.activeElement;

    switchView(view, false);
    setAuthFieldsActive(true);

    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('lm-is-open');
    document.body.style.overflow = 'hidden';
    isOpen = true;

    function finishOpen() {
      if (!isOpen || !isAnimating || overlay.classList.contains('lm-is-closing')) return;
      isAnimating = false;
      trapFocus();
    }

    card.addEventListener(
      'transitionend',
      function onOpen(e) {
        if (e.target !== card) return;
        card.removeEventListener('transitionend', onOpen);
        finishOpen();
      },
      { once: true },
    );

    setTimeout(finishOpen, 450);
    bindMouseParallax();
  }

  function closeModal() {
    if (!isOpen) return;
    isAnimating = true;
    overlay.classList.add('lm-is-closing');

    var closeFinished = false;

    function finishClose() {
      if (closeFinished) return;
      closeFinished = true;
      overlay.classList.remove('lm-is-open', 'lm-is-closing');
      overlay.setAttribute('aria-hidden', 'true');
      setAuthFieldsActive(false);
      document.body.style.overflow = '';
      isOpen = false;
      isAnimating = false;
      pendingCheckout = false;
      setReturnTo(defaultReturnTo);
      releaseFocusTrap();
      unbindMouseParallax();
      if (lastFocusedEl) lastFocusedEl.focus();
    }

    card.addEventListener(
      'transitionend',
      function onClose(e) {
        if (e.target !== card) return;
        card.removeEventListener('transitionend', onClose);
        finishClose();
      },
      { once: true },
    );

    setTimeout(finishClose, 450);
  }

  function switchView(viewName, animate) {
    if (animate === undefined) animate = true;
    if (viewName === currentView && animate) return;

    currentView = viewName;
    const cfg = VIEW_CONFIG[viewName];

    document.querySelectorAll('.lm-view').forEach(function (v) {
      if (v.dataset.view === viewName) {
        v.removeAttribute('hidden');
      } else {
        v.setAttribute('hidden', '');
      }
    });

    document.querySelectorAll('.lm-editorial__label').forEach(function (l) {
      l.style.display = l.dataset.view === viewName ? '' : 'none';
    });

    if (cfg && animate) {
      const hl = document.querySelector('.lm-editorial__headline');
      if (hl) {
        hl.style.opacity = '0';
        setTimeout(function () {
          updateHeadlineLines(cfg.lines);
          hl.style.opacity = '1';
        }, 250);
      }
    } else if (cfg) {
      updateHeadlineLines(cfg.lines);
    }
  }

  function updateHeadlineLines(lines) {
    document.querySelectorAll('.lm-editorial__line').forEach(function (el, i) {
      el.textContent = lines[i] || '';
    });
  }

  function bindMouseParallax() {
    if (!decoEl || !leftEl) return;
    overlay.addEventListener('mousemove', onMouseMove);
  }

  function unbindMouseParallax() {
    overlay.removeEventListener('mousemove', onMouseMove);
    if (mouseMoveRAF) {
      cancelAnimationFrame(mouseMoveRAF);
      mouseMoveRAF = null;
    }
    if (decoEl) {
      decoEl.querySelectorAll('.lm-deco__word').forEach(function (el) {
        el.style.transform = '';
      });
    }
  }

  function onMouseMove(e) {
    if (mouseMoveRAF) cancelAnimationFrame(mouseMoveRAF);
    mouseMoveRAF = requestAnimationFrame(function () {
      const rect = overlay.getBoundingClientRect();
      const nx = (e.clientX - rect.left) / rect.width - 0.5;
      const ny = (e.clientY - rect.top) / rect.height - 0.5;
      const words = decoEl.querySelectorAll('.lm-deco__word');
      const factors = [6, -5, 4];
      words.forEach(function (el, i) {
        const f = factors[i] || 4;
        if (i === 2) {
          el.style.transform =
            'translate(calc(-50% + ' + nx * f + 'px), calc(-50% + ' + ny * f + 'px))';
        } else {
          el.style.transform = 'translate(' + nx * f + 'px, ' + ny * f + 'px)';
        }
      });
    });
  }

  function getFocusableEls() {
    return Array.from(
      card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
          'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    );
  }

  function trapFocus() {
    const focusable = getFocusableEls();
    if (focusable.length) focusable[0].focus();

    focusTrap = function (e) {
      if (e.key !== 'Tab') return;
      const els = getFocusableEls();
      if (!els.length) return;
      const first = els[0];
      const last = els[els.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', focusTrap);
  }

  function releaseFocusTrap() {
    if (focusTrap) {
      document.removeEventListener('keydown', focusTrap);
      focusTrap = null;
    }
  }

  function initPasswordToggles() {
    document.querySelectorAll('.lm-field__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.dataset.target;
        var input = document.getElementById(targetId);
        if (!input) return;
        var isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        var eyeShow = btn.querySelector('.lm-eye--show');
        var eyeHide = btn.querySelector('.lm-eye--hide');
        if (eyeShow) eyeShow.style.display = isPassword ? 'none' : '';
        if (eyeHide) eyeHide.style.display = isPassword ? '' : 'none';
        btn.setAttribute('aria-pressed', String(isPassword));
      });
    });
  }

  function validateRequiredFields(form, fieldNames) {
    var valid = true;

    fieldNames.forEach(function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      if (!input) return;
      var empty = !input.value.trim();
      var field = input.closest('.lm-field');
      if (field) field.classList.toggle('lm-field--error', empty);
      if (empty) valid = false;
    });

    if (!valid) {
      var firstErr = form.querySelector('.lm-field--error .lm-field__input');
      if (firstErr) firstErr.focus();
    }

    return valid;
  }

  function initFormValidation() {
    var loginForm = document.getElementById('lm-form-login');
    if (loginForm) {
      loginForm.addEventListener('submit', function (e) {
        if (isLegacyAuth) {
          if (!validateRequiredFields(loginForm, ['customer[email]', 'customer[password]'])) {
            e.preventDefault();
          }
          return;
        }

        if (!validateRequiredFields(loginForm, ['login_hint'])) {
          e.preventDefault();
          return;
        }

        var submitBtn = document.getElementById('lm-login-submit');
        if (submitBtn) {
          submitBtn.disabled = true;
          var label = submitBtn.querySelector('span');
          if (label) label.textContent = window.hrcI18n?.redirecting || 'Redirecting…';
        }
      });
    }

    if (isLegacyAuth) {
      var regForm = document.getElementById('lm-form-register');
      if (regForm) {
        regForm.addEventListener('submit', function (e) {
          if (!validateRequiredFields(regForm, ['customer[email]', 'customer[password]'])) {
            e.preventDefault();
          }
        });
      }

      var forgotForm = document.getElementById('lm-form-forgot');
      if (forgotForm) {
        forgotForm.addEventListener('submit', function (e) {
          if (!validateRequiredFields(forgotForm, ['email'])) {
            e.preventDefault();
          }
        });
      }
    }

    document.querySelectorAll('.lm-field__input').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.value.trim()) {
          var field = input.closest('.lm-field');
          if (field) field.classList.remove('lm-field--error');
        }
      });
    });
  }

  function checkShopifyErrors() {
    if (!isLegacyAuth) return;

    var hasLoginErr =
      document.getElementById('lm-form-login') &&
      document.querySelector('#lm-form-login .lm-alert');
    var hasRegErr =
      document.getElementById('lm-form-register') &&
      document.querySelector('#lm-form-register .lm-alert');
    var hasForgotOk = document.querySelector('#lm-form-forgot .lm-alert--success');
    var hasForgotErr = document.querySelector('#lm-form-forgot .lm-alert:not(.lm-alert--success)');

    if (hasLoginErr) {
      openModal('login');
      return;
    }
    if (hasRegErr) {
      openModal('register');
      return;
    }
    if (hasForgotOk || hasForgotErr) {
      openModal('forgot');
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeModal();
  });

  document.querySelectorAll('[data-switch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      switchView(btn.dataset.switch, true);
    });
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lm-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openModal(trigger.dataset.lmView || 'login');
  });

  document.addEventListener('lm:open', function (e) {
    var detail = e.detail || {};
    openModal(detail.view || 'login', { checkout: !!detail.checkout });
  });

  document.addEventListener('lm:close', function () {
    closeModal();
  });

  /**
   * Optional: require login before checkout (theme setting require_login_for_checkout).
   * When off, guests proceed to /checkout without the login modal.
   */
  function isCheckoutControl(el) {
    if (!el || !el.closest) return false;
    if (el.closest('[name="checkout"]')) return true;
    if (el.closest('.hrc-dynamic-checkout-buttons')) return true;
    if (el.closest('.shopify-payment-button')) return true;
    if (el.closest('[data-shopify="payment-button"]')) return true;
    return false;
  }

  function openCheckoutLogin(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    openModal('login', { checkout: true });
  }

  if (!isLoggedIn && requireLoginCheckout) {
    document.addEventListener(
      'click',
      function (e) {
        if (!isCheckoutControl(e.target)) return;
        openCheckoutLogin(e);
      },
      true,
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;

        var submitter = e.submitter;
        if (submitter && submitter.getAttribute('name') === 'checkout') {
          openCheckoutLogin(e);
          return;
        }

        // Cart notification checkout form (button is inside the form)
        if (form.id === 'hrc-cart-notification-form') {
          openCheckoutLogin(e);
        }
      },
      true,
    );
  }

  initPasswordToggles();
  initFormValidation();
  setAuthFieldsActive(false);
  checkShopifyErrors();
})();
